'use strict';

angular.module('ListAccessRequestControllers')

.controller('DisplayRequestsController', ['$scope', '$rootScope', '$state', '$stateParams', 'getRequests', 'requestStatus', 'userAccessRequestService', function ($scope, $rootScope, $state, $stateParams, getRequests, requestStatus, userAccessRequestService) {

    $scope.search = {};
    $scope.search.term = $stateParams.searchTerm;
    $scope.custodian = $stateParams.custodian;
    $scope.employeeId = $stateParams.employeeId;
    $scope.requestStatus = requestStatus;
    $scope.userRequests = [];

    $scope.byEmployee = $scope.employeeId > 0;

    // Refresh user requests list
    $scope.refreshRequests = function () {
        getRequests($stateParams)
        .then(function (userRequests) {

            $scope.userRequests = _.map(userRequests.Requests, function (request) {
                request.Custodian = $stateParams.custodian;
                request.SystemsInfos = userAccessRequestService.getPendingSystems(request);
                return request;
            });

            // Pagination
            $scope.nbRequestsInTotal = userRequests.RequestsInfos.NbRequestsInTotal;

            $scope.pagination = {}
            $scope.pagination.requestsPerPage = 8;
            $scope.pagination.currentPage = parseInt($stateParams.page);
            $scope.pagination.totalRequests = $scope.nbRequestsInTotal;

            $scope.withPreviousRequests = $scope.pagination.currentPage > 1;

            var nbRequestsPrevious = ($scope.pagination.currentPage - 1) * $scope.pagination.requestsPerPage;
            var nbRequestsDisplayed = (nbRequestsPrevious + $scope.userRequests.length);
            $scope.withNextRequests = $scope.pagination.totalRequests > nbRequestsDisplayed;
        });
    }
    $scope.refreshRequests();

    // My Assigned Requests
    $scope.isMyAssignedRequests = false;
    if ($state.is('userAccessRequest.request.assignedToMe')) {
        $scope.isMyAssignedRequests = true;
    }

    // Pagination    
    $scope.nextPage = function () {
        $state.go($state.current.name, {
            page: $scope.pagination.currentPage + 1,
            custodian: $scope.custodian
        });
    }

    $scope.previousPage = function () {
        $state.go($state.current.name, {
            page: $scope.pagination.currentPage - 1,
            custodian: $scope.custodian
        });
    }

    // Search
    $scope.searchRequests = function () {
        $stateParams.searchTerm = $scope.search.term;
        $scope.refreshRequests();
    }

    // New Request
    $scope.newRequest = function () {
        userAccessRequestService.create($scope.employeeId).then(function (newRequest) {
            if (_.isUndefined(newRequest.UserAccessRequestID)) return;

            $state.go('userAccessRequest.edit',
                      { userAccessRequestId: newRequest.UserAccessRequestID });
        });
    }

    $rootScope.$on('requestIsProcessed', function (event, args) {
        var updatedRequest = args.UserAccessRequest;

        var requestsToUpdate = _.takeWhile($scope.userRequests, function (request) {
            return request.UserAccessRequestID === updatedRequest.UserAccessRequestID;
        });
        if (requestsToUpdate.length !== 1) return;

        var requestToUpdate = requestsToUpdate[0];
        requestToUpdate.NbCardsToProcess = 0;
        requestToUpdate.RequestStatusCssClass = updatedRequest.RequestStatusCssClass;
        requestToUpdate.BoxRequestStatusCssClass = updatedRequest.BoxRequestStatusCssClass;
        requestToUpdate.RequestStatus = updatedRequest.RequestStatus;
        requestToUpdate.RequestStatusLabel = updatedRequest.RequestStatusLabel;
        requestToUpdate.UpdatedTimestamp = updatedRequest.UpdatedTimestamp;
    });

    // Is selected request
    $scope.isSelectedRequest = function (requestId) {
        return $state.includes('**.processRequest') &&
               $state.params.userAccessRequestID === requestId;
    }
}]);